import { userAPI } from "../services/api";
import { APP_NAME } from "./constant";

const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const initiateRazorpayPayment = async (onPaymentSuccess) => {
  try {
    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      throw new Error("Razorpay SDK failed to load. Please check your connection.");
    }

    // Create order from backend (POST /user/create-order)
    const orderResponse = await userAPI.createRazorpayOrder();

    if (!orderResponse.success) {
      throw new Error(orderResponse.error || "Failed to create order");
    }

    const { order_id, amount, currency, key_id, repayment_amount } = orderResponse;

    const options = {
      key: key_id,
      amount: amount, // Amount in paise
      currency: currency,
      name: APP_NAME,
      description: `Loan Repayment - ₹${repayment_amount}`,
      order_id: order_id,
      handler: function (response) {
        if (onPaymentSuccess) {
          onPaymentSuccess({
            success: true,
            amount: repayment_amount,
            order_id: response.razorpay_order_id,
            payment_id: response.razorpay_payment_id,
          });
        }
      },
      theme: {
        color: "#FF6B35",
      },
      modal: {
        ondismiss: function () {
          console.log("Payment modal closed");
        },
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();

    return true;
  } catch (error) {
    console.error("Razorpay payment initiation failed:", error);
    throw error;
  }
};
